// Stadia Maps authenticates browser requests by domain (Referer), so no API key is needed here.
// Every domain that serves the frontend must be registered in the Stadia dashboard
// (Property -> Authentication Configuration -> Add Domain); localhost works without it.
export const MAP_TILE_LAYER = {
  url: "https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png",
  attribution:
    '&copy; <a href="https://www.stadiamaps.com/" target="_blank" rel="noopener noreferrer">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank" rel="noopener noreferrer">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors',
};
